export default "__VITE_ASSET__CSGycvQE__"